/* eslint-disable import/prefer-default-export */
export const PAGE_TYPE = "LegalPartners";

export const REGISTRATION_FORM_SUBMITTED = "registration_form_submitted";
export const REGISTRATION_FORM_ERROR = "registration_form_error";
